import type { Edition } from '../types';

/**
 * Simple function to enforce type checks (e.g. ['standard'].includes(edition) is valid code, but likely a bug)
 */
export function isEditionOneOf(edition: Edition, possibleMatches: Edition[]): boolean {
	return possibleMatches.includes(edition);
}
